import React, {useState} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './QuillTextEditor.css'
import ValidationUI from "../ValidationUI";
import axios from 'axios'
import {toastr} from "react-redux-toastr";
import moment from "moment";
import withQuery from "with-query";

import ImageResize from 'quill-image-resize';
import {Trash, CornerDownRight, CornerUpRight, CornerLeftDown, CornerRightDown, XSquare, X, AlignLeft, AlignRight, AlignCenter, ChevronRight, Columns, Table2, Image} from 'lucide-react';
import ReactDOM from "react-dom";
import ImageContextMenu from "./quillTextEditorUtils/imageContextMenu";
import TableResize from "./quillTextEditorUtils/tableResize";
import TableSelector from "./quillTextEditorUtils/tableSelectorPopUp";
import {sanitizeHtml} from "../../utils/sanitizeHtml";
import CustomTableResize from "./quillTextEditorUtils/tableResize";


const Quill = ReactQuill.Quill

const Font = Quill.import('formats/font')
Font.whitelist = ['', 'Arial', 'Georgia', 'Helvetica', 'Tahoma', 'Times', 'Trebuchet', 'Verdana']
Quill.register(Font, true)

const Embed = Quill.import('blots/embed');
class ImageBlot extends Embed {
    static create(value) {
        const node = super.create();

        // Create the image element
        const img = document.createElement('img');

        img.setAttribute('src', value.src || value);  // || value case is for the old images only, in that case tha value is a string containing the src directly
        //img.classList.add('ql-image'); // Helps the resize module recognize the image
        /*img.setAttribute('alt', value.alt || ''); // Support alt text*/

        const styleOfOldImages = 'max-width: 100%; height: auto; display: block;'
        if (value && !value.src) {
            img.setAttribute('style', styleOfOldImages); // Apply any styles that the old images had
        }

        if (value.width) {
            img.setAttribute('width', value.width); // Apply any styles if provided
        }
        if (value.height) {
            img.setAttribute('height', value.height); // Apply any styles if provided
        }
        if (value.classList && Array.isArray(value.classList)) {
            img.classList.add(...value.classList); // Restore the classList
        }

        //container.appendChild(img);
        node.appendChild(img);

        return node;
    }

    static value(node) {
        // Find the img element within the container
        const img = node.querySelector('img');
        if (!img) return null;

        return {
            src: img.getAttribute('src'),
            width: img.getAttribute('width'),
            height: img.getAttribute('height'),
            classList: Array.from(img.classList),
        };
    }

    attach() {
        super.attach();
        const img = this.domNode.querySelector('img');

        // Attach to image element
        if (img && !img._contextMenuAttached) {
            img.addEventListener('contextmenu', this.handleContextMenu.bind(this));
            img._contextMenuAttached = true;
        }

        // Attach global listener (once per instance)
        if (!this._globalListenerAttached) {
            document.addEventListener('contextmenu',
                (e) => {
                if (this.isEventOnImage(e)) {
                    e.preventDefault(); // Block default browser menu
                    this.handleContextMenu(e);
                }
            },
                true
            );
            this._globalListenerAttached = true;
        }
    }
    isEventOnImage(e) {
        const img = this.domNode.querySelector('img');
        const numberOfTargetChildren = e.target.children.length
        const expectedNumberOfTargetChildren = 5
        const targetFirstChildHTML = e.target.children[0]?.outerHTML
        const expectedTargetHTML = `<div style=\"position: absolute; height: 12px; width: 12px; background-color: white; border: 1px solid rgb(119, 119, 119); box-sizing: border-box; opacity: 0.8; cursor: nwse-resize; left: -6px; top: -6px;\"></div>`
        const clickedOnImage = numberOfTargetChildren === expectedNumberOfTargetChildren && targetFirstChildHTML === expectedTargetHTML
        return clickedOnImage
    }

    handleContextMenu(e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove existing context menu
        const existingMenu = document.querySelector('.image-context-menu');
        if (existingMenu) {
            existingMenu.parentElement.remove();
        }

        const menuContainer = document.createElement('div');
        //const { adjustedX, adjustedY } = this.adjustMenuPosition(e.pageX, e.pageY);
        const { subMenuPosition, menuPosition } = this.adjustMenuPosition(e.pageX);

        // Create and render context menu
        ReactDOM.render(
            <ImageContextMenu
                x={menuPosition}
                y={e.pageY - 15}
                onClose={() => {
                    if (document.body.contains(menuContainer)) {
                        document.body.removeChild(menuContainer);
                    }
                }}
                onAction={(action) => {
                    this.handleImageAction(action);
                    if (document.body.contains(menuContainer)) {
                        document.body.removeChild(menuContainer);
                    }
                }}
                subMenuPosition={subMenuPosition}
            />,
            menuContainer
        );

        document.body.appendChild(menuContainer);

        // Close menu when clicking outside
        const closeMenu = (e) => {
            if (!menuContainer.contains(e.target)) {
                if (document.body.contains(menuContainer)) {
                    document.body.removeChild(menuContainer);
                }
                document.removeEventListener('click', closeMenu);
            }
        };

        setTimeout(() => {
            document.addEventListener('click', closeMenu);
        }, 0);
    }

    adjustMenuPosition(x) {
        const menuWidth = 220; // Approximate menu width
        const subMenuWidth = menuWidth + 200

        const leftSpace = window.innerWidth - x;
        const menuPosition = leftSpace > menuWidth ? x + 1 : x - 165
        const subMenuPosition = leftSpace > subMenuWidth ? {left : '100%'} : {right: '100%'}

        return { subMenuPosition, menuPosition};
    }

    handleImageAction(action) {
        const node = this.domNode;
        let img

        const quillContainer = this.parent.parent.domNode.parentNode.children;
        const expectedTargetHTML = `<div style=\"position: absolute; height: 12px; width: 12px; background-color: white; border: 1px solid rgb(119, 119, 119); box-sizing: border-box; opacity: 0.8; cursor: nwse-resize; left: -6px; top: -6px;\"></div>`
        const imageResizeFrameDiv = Array.from(quillContainer).find(child => child.children.length === 5 && child.children[0].outerHTML === expectedTargetHTML)
        if (imageResizeFrameDiv) {
            // If resize frame exists, find the image it's associated with
            // The resize frame's position corresponds to the selected image
            const frameLeft = parseInt(imageResizeFrameDiv.style.left);
            const frameTop = parseInt(imageResizeFrameDiv.style.top);
            const allImages = Array.from(this.parent.parent.domNode.parentNode.querySelectorAll('img'));

            img = allImages
                .find(imgEl =>
                    imgEl &&
                    Math.abs(imgEl.offsetLeft - frameLeft) <= 1 &&
                    Math.abs(imgEl.offsetTop - frameTop) <= 1
                );
        } else {
            img = node.querySelector('img')
        }

        // Remove existing alignment classes
        const alignmentClasses = [
            'align-left', 'align-right', 'align-center',
            'align-left-with-text', 'align-right-with-text', 'align-center-with-text'
        ];

        if (img){
            img.classList.remove(...alignmentClasses);
            const parent = img.parentNode.parentNode.parentNode // img -> span -> custom-image -> p

            // Handle different actions
            const newParagraph = document.createElement('p');
            const textNodes = Array.from(parent.childNodes).filter(node => node.localName !== 'custom-image');
            const textNodesHtml = textNodes.map(node => {
                return node.nodeType === Node.TEXT_NODE ? node.textContent : node.outerHTML})
                .join('')
            newParagraph.innerHTML = textNodesHtml
            switch (action) {
                case 'alignLeft':
                case 'alignRight':
                case 'alignCenter':
                    parent.removeAttribute('contenteditable');
                    img.classList.add(`align-${action.replace('align', '').toLowerCase()}`);
                    break;
                case 'alignLeftWithText':
                    parent.setAttribute('contenteditable', 'false'); // Prevent Quill from editing the table as a whole
                    // Remove all text nodes
                    textNodes.forEach(textNode => {
                        parent.removeChild(textNode);
                    });
                    parent.insertAdjacentElement('afterend', newParagraph);
                    img.classList.add('align-left-with-text');
                    break;
                case 'alignRightWithText':
                    parent.setAttribute('contenteditable', 'false'); // Prevent Quill from editing the table as a whole
                    // Remove all text nodes
                    textNodes.forEach(textNode => {
                        parent.removeChild(textNode);
                    });
                    parent.insertAdjacentElement('afterend', newParagraph);
                    img.classList.add('align-right-with-text');
                    break;
                case 'alignCenterWithText' :
                    parent.removeAttribute('contenteditable');
                    break
                case 'removeImage':
                    img.parentNode.parentNode.remove()
                    if (imageResizeFrameDiv){imageResizeFrameDiv.style.display = 'none';}
                    break;
            }
            const leftOffset = img.offsetLeft + 'px'
            const topOffset = img.offsetTop + 'px'
            if (imageResizeFrameDiv && leftOffset){
                imageResizeFrameDiv.style.left = leftOffset;
            }
            if (imageResizeFrameDiv && topOffset){
                imageResizeFrameDiv.style.top = topOffset;
            }
        }
    }
}

ImageBlot.blotName = 'image';
ImageBlot.tagName = 'custom-image';
Quill.register(ImageBlot)

Quill.register('modules/imageResize', ImageResize);

const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');
const Block = Quill.import('blots/block');

class TableBlot extends BlockEmbed {
    static selectedCell = null; // Store the currently selected <td>

    static create(value) {
        // Check if `value` includes HTML to reconstruct the saved table

        const container = super.create(); // Use the `table` tag directly as the blot
        container.setAttribute('class', 'custom-table');
        container.setAttribute('contenteditable', 'false'); // Empêcher Quill d'éditer la table entière

        if (value.classList && Array.isArray(value.classList)) {
            container.classList.add(...value.classList); // Restore the classList
        }
        else{
            container.classList.add('table-align-left')
        }

        if (value.html) {
            container.innerHTML = value.html; // Set the HTML
            return container
        }

        const { rows = 2, columns = 2 } = value || {};
        // Create <tbody>
        const tbody = document.createElement('tbody');
        for (let i = 0; i < rows; i++) {
            const tr = document.createElement('tr');
            for (let j = 0; j < columns; j++) {
                const td = document.createElement('td');
                td.contentEditable = 'false'; // Allow cell content editing
                const div = document.createElement('div');
                div.style.height = '100%'; // Make the div take up the full height of the td
                div.contentEditable = 'false'; // Allow cell content editing

                const p = document.createElement('p');
                p.style.height = '100%'; // Make the div take up the full height of the td
                p.contentEditable = 'true'; // Allow typing only inside the <p>
                p.innerHTML = '<br>'; // Ensure an empty but non-deletable paragraph


                div.appendChild(p);
                td.appendChild(div);
                tr.appendChild(td);
            }
            tbody.appendChild(tr);
        }
        container.appendChild(tbody);
        return container;
    }

    static value(node) {
        const rows = node.querySelectorAll('tbody tr').length;
        const columns = node.querySelectorAll('tbody tr:first-child td').length;

        return {
            classList: Array.from(node.classList),
            rows,
            columns,
            html: node.innerHTML // Include full HTML to rebuild the table with styles and everything
        };
    }

    attach() {
        super.attach();
        // Add event listener to track selected cell
        this.domNode.addEventListener('focusin', (event) => {
            const td = event.target.closest('td'); // Find the closest <td>
            if (td) {
                TableBlot.selectedCell = td; // Store the selected <td>
            }
        });
    }
}

TableBlot.blotName = 'table'
TableBlot.tagName = 'table' // Wraps the table inside a div
Quill.register(TableBlot)

// Custom SVG for the table button
const tableIcon = `
<svg width="16" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="7" height="7"></rect>
    <rect x="14" y="3" width="7" height="7"></rect>
    <rect x="14" y="14" width="7" height="7"></rect>
    <rect x="3" y="14" width="7" height="7"></rect>
</svg>`;
// Add the SVG to the Quill toolbar icons
const icons = ReactQuill.Quill.import('ui/icons');
icons['table'] = tableIcon;

Quill.register('modules/customTableResize', CustomTableResize);
class Editor extends React.Component {
    constructor (props) {
        super(props)
        this.quillRef = React.createRef()
        this.state = {isTableSelectorOpen: false}
        this.handleChange = this.handleChange.bind(this)
        this.selectLocalImage = this.selectLocalImage.bind(this)
        this.saveToServer = this.saveToServer.bind(this)
        this.insertToEditor = this.insertToEditor.bind(this)

        this.handleInsertTable = this.handleInsertTable.bind(this)
        this.handleTableDialogClose = this.handleTableDialogClose.bind(this)
        this.handleTableSelect = this.handleTableSelect.bind(this)
    }


    componentDidMount() {
        this.addTooltipsToToolbar();


        const quill = this.quillRef?.current?.getEditor();
        if (quill) {
            // Gestion des styles via la barre d'outils
            quill.getModule('toolbar').addHandler('bold', () => this.toggleTextStyle('strong'));
            quill.getModule('toolbar').addHandler('italic', () => this.toggleTextStyle('em'));
            quill.getModule('toolbar').addHandler('underline', () => this.toggleTextStyle('u'));
            quill.getModule('toolbar').addHandler('strike', () => this.toggleTextStyle('s'));
            quill.getModule('toolbar').addHandler('color', (value) => this.applyTextStyle('color', value));
            quill.getModule('toolbar').addHandler('background', (value) => this.applyTextStyle('background-color', value));
            quill.getModule('toolbar').addHandler('indent', (value) => this.applyIndent(value));
            quill.getModule('toolbar').addHandler('list', (value) => {this.applyList(value);})
            quill.getModule('toolbar').addHandler('clean', () => {this.applyClean()});
            quill.getModule('toolbar').addHandler('font', (value) => {this.applyFont('font', value)});
            quill.getModule('toolbar').addHandler('size', (value) => {this.applyFont('size', value)});
        }
    }

    addTooltipsToToolbar() {
        const tooltips = {
            "font": "Nom de police",
            "size": "Taille de police",
            'align': 'Alignement du texte',
            'bold': 'Gras',
            'italic': 'Italique',
            'underline': 'Souligné',
            "strike": "Barré",
            'color': 'Couleur de police',
            'background': 'Couleur de surlignage',
            'list[value="ordered"]': 'Numérotation',
            'list[value="bullet"]': 'Puce',
            'indent[value="-1"]': 'Déplacer vers la gauche',
            'indent[value="+1"]': 'Déplacer vers la droite',
            "link": "Lien",
            "image": "Insérer une image",
            'table': "Insérer un tableau",
            'clean': 'Supprimer la mise en forme',
        };

        // Select toolbar buttons and add tooltips
        Object.keys(tooltips).forEach((key) => {
            const button = document.querySelector(`.ql-${key}`);
            if (button) {
                button.setAttribute('title', tooltips[key]);
            }
        });
    }

    // Fonction pour ajouter/supprimer un style (bold, italic, underline, strikethrough)
    applyFont(style, value) {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (leafBlot instanceof TableBlot) {
            const cell = TableBlot.selectedCell;
            if (cell) {
                const p = cell.querySelector('p');
                const targetedClassName = style === 'font' ? 'ql-font-' : 'ql-size-'
                if (p) {
                    p.classList.forEach((cls) => {
                        if (cls.startsWith(targetedClassName)) {
                            p.classList.remove(cls);
                        }
                    });
                    if (value) { p.classList.add(targetedClassName+value) }
                }
            }
        } else {
            // Comportement normal de Quill pour le texte hors tableau
            quill.format(style === 'font' ? 'font' : 'size', value);
        }
    }

    // Fonction pour ajouter/supprimer un style (bold, italic, underline, strikethrough)
    toggleTextStyle(tag) {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (leafBlot instanceof TableBlot) {
            const cell = TableBlot.selectedCell;
            if (cell) {
                const p = cell.querySelector('p');
                if (p) {
                    if (p.innerHTML.includes(`<${tag}>`)) {
                        // Supprime le style
                        const regex = new RegExp(`<${tag}>(.*?)<\/${tag}>`, 'g');
                        p.innerHTML = p.innerHTML.replace(regex, '$1');
                    } else {
                        // Applique le style
                        p.innerHTML = `<${tag}>${p.innerHTML}</${tag}>`;
                    }
                }
            }
        } else {
            // Comportement normal de Quill pour le texte hors tableau
            const format = tag === 'strong' ? 'bold' : tag === 'em' ? 'italic' : tag === 'u' ? 'underline' : 'strike';
            quill.format(format, !quill.getFormat(range)[format]);
        }
    }

    // 🎨 Appliquer un style CSS générique (color, background)
    applyTextStyle(style, value) {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (leafBlot instanceof TableBlot) {
            const cell = TableBlot.selectedCell;
            if (cell) {
                const p = cell.querySelector('p');
                if (p) {
                    if (!value) {
                        p.style.removeProperty(style);
                    } else {
                        p.style[style] = value;
                    }
                }
            }
        } else {
            quill.format(style === 'background-color' ? 'background' : 'color', value || false);
        }
    }

    applyIndent(value) {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (leafBlot instanceof TableBlot) {
            const cell = TableBlot.selectedCell;
            if (cell) {
                const p = cell.querySelector('p');
                if (p) {
                    let currentIndent = 0;

                    // Vérifie si une classe ql-indent-* est déjà présente
                    p.classList.forEach((cls) => {
                        if (cls.startsWith('ql-indent-')) {
                            currentIndent = parseInt(cls.replace('ql-indent-', ''), 10) || 0;
                            p.classList.remove(cls);
                        }
                    });

                    // Applique la nouvelle indentation
                    if (value === '+1') {
                        p.classList.add(`ql-indent-${currentIndent + 1}`);
                    } else if (value === '-1' && currentIndent > 0) {
                        p.classList.add(`ql-indent-${currentIndent - 1}`);
                    }
                }
            }
        } else {
            quill.format('indent', value);
        }
    }

    applyList(type) {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (!(leafBlot instanceof TableBlot)) {quill.format('list', type);}
    }

    applyClean() {
        const quill = this.quillRef?.current?.getEditor();
        const range = quill?.getSelection();
        if (!range) return;

        const [leafBlot] = quill.getLeaf(range.index);

        if (leafBlot instanceof TableBlot) {
            const cell = TableBlot.selectedCell;
            if (cell) {
                const p = cell.querySelector('p');
                if (p) {
                    // Supprimer les balises de style (bold, italic, underline, strike)
                    p.innerHTML = p.innerHTML
                        .replace(/<\/?(strong|b|em|i|u|s|strike)>/g, '') // Supprime les balises HTML de style

                    p.style.removeProperty('color');
                    p.style.removeProperty('background-color');

                    // Supprimer les classes d'indentation
                    p.classList.forEach(className => {
                        if (className.startsWith('ql-indent-')) {
                            p.classList.remove(className);
                        }
                    });
                }
            }
        } else {
            quill.removeFormat(range.index, range.length);
        }
    }


    handleChange (html) {
        const sanitized = sanitizeHtml(html)
        // Remember this as our own echo so the next render doesn't feed it
        // back into ReactQuill's controlled `value` and force a re-parse of
        // the live DOM (which desyncs Quill's selection/table state and
        // causes an update loop). Only genuinely external value changes
        // (e.g. loading a different record) should trigger a resync.
        this.lastEmittedValue = sanitized
        this.props.onChange(sanitized)
    }

    selectLocalImage() {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();

        // Listen upload local image and save to server
        input.onchange = () => {
            const file = input.files[0];

            // file type is only image.
            if (/^image\//.test(file.type)) {
                this.saveToServer(file)
            } else {
                console.warn('You could only upload images.');
            }
        };
    }

    saveToServer(file) {
        const data = new FormData()

        const fileSize = file.size
        const chunkSize = 15 * 1024 * 1024

        let fileChunk = null, chunkNb = 0
        for (let start = 0; start < fileSize; start += chunkSize, chunkNb++) {
            if (start + chunkSize > fileSize) {
                fileChunk = file.slice(start, fileSize)
            }
            else {
                fileChunk = file.slice(start, start + chunkSize)
            }
            data.append('imageChunks', fileChunk, file.name)
        }

        if(this.props.user) {
            data.append('user', JSON.stringify(this.props.user))
        }
        data.append('fileSize', fileSize)
        data.append('chunkNb', chunkNb)

        const options = {
            headers: { 'Content-Type': 'multipart/form-data' }
        }

        axios.post('/image', data, options)
            .then(res => {
                const {name, date} = res.data
                const fullDate = moment(date).format('YYYY-MM-DD_HH-mm-ss')
                const url = `/image/${fullDate}_${name}`
                this.insertToEditor(url)
            })
            .catch(err => {
                if (err.response?.status === 413) {
                    toastr.error(this.props.t('tooLargeFile'))
                } else if (err.response?.status === 415) {
                    toastr.error(this.props.t('unsupportedImageType'))
                } else if (err.response?.status === 400) {
                    toastr.error(this.props.t('invalidFileName'))
                } else {
                    toastr.error(this.props.t('errorUploading'))
                }
            })
    }

    insertToEditor(url) {
        const editor = this.quillRef.current.getEditor()
        const range = editor.getSelection()

        // The /image route requires an accessId (see accessMiddleware server-side) or it
        // 500s — every other image/file display in the app appends it the same way.
        const queriedUrl = withQuery(url, {
            accessId: this.props.accessId,
            groupModelId: this.props.groupModel && this.props.groupModel.id
        })

        const hostname = window.location.hostname
        const link = hostname === 'localhost'
            ?  `http://${hostname}:9003${queriedUrl}`
            :  `https://${hostname}${queriedUrl}`

        editor.insertEmbed(range.index, 'image', {
            src: link,
            classList: ['alignCenterWithText'],
            //alignment: 'center-with-text', // Or dynamically set based on user input
            //style: 'max-width: 100%; height: auto; display: block;'
        });
    }

    handleInsertTable = () => {
        const editor = this.quillRef.current.getEditor();
        const range = editor.getSelection();

        // Save the current selection
        this.savedRange = range;

        this.setState({
            isTableSelectorOpen: true,
        });
    };

    handleTableDialogClose = () => {
        const editor = this.quillRef.current.getEditor();
        const range = editor.getSelection();
        this.setState({
            isTableSelectorOpen: false,
        });
    };

    handleTableSelect = (tableConfig) => {
        this.setState({
            isTableSelectorOpen: false,
        }, () => {
            const editor = this.quillRef.current.getEditor();
            const length = editor.getLength();
            // Restore the saved selection
            editor.setSelection(this.savedRange || length)
            const range = editor.getSelection();
            editor.insertEmbed(range.index, 'table', tableConfig);
        });
    };

    static formats = [
        //'header',
        'font', 'size',
        'bold', 'italic', 'underline', 'strike',
        //'blockquote',
        'color', 'background', 'list', 'bullet', 'indent', 'align',
        'link',
        'image',
        'table'
        //, 'video'
    ]

    render() {
        const { value, touched, error, path, required, t, readOnly, disabled, placeholder, style = {} } = this.props

        const modules = {
            toolbar: {
                container: [
                    [
                        //{ 'header': '1'}, {'header': '2'},
                        { 'font': Font.whitelist },
                    ],
                    [{size: []}],
                    //[],
                    [{align: []}, 'bold', 'italic', 'underline', 'strike',
                        //'blockquote'
                    ],
                    [{ 'color': [] }, { 'background': [] }],
                    [{'list': 'ordered'}, {'list': 'bullet'},
                        {'indent': '-1'}, {'indent': '+1'}],
                    ['link', 'image', 'table'],
                    ['clean'],
                ],
                handlers: {
                    image: this.selectLocalImage,
                    table: this.handleInsertTable
                }
            },
            clipboard: {
                // toggle to add extra line breaks when pasting HTML:
                matchVisual: false,
            },
            imageResize: {
                modules: ['Resize', 'DisplaySize'], // Excludes 'Align'
            },
            customTableResize: {}
        }

        if(readOnly) {
            return (
                <div className="ql-container ql-snow ql-disabled" style={{...style, border: 'none'}}>
                    <div className="ql-editor" data-gramm="false" contentEditable="false">
                        <div dangerouslySetInnerHTML={{__html: sanitizeHtml(value)}} />
                    </div>
                </div>
            )
        }

        return (
            <div style={style}>
                <label className="QuillTextEditor-label">{t(path)} {required && "*"}</label>
                <div style={{padding: '5px'}}>
                    <ReactQuill
                        ref={this.quillRef}
                        theme={'snow'}
                        readOnly={disabled}
                        onChange={this.handleChange}
                        {...(value !== this.lastEmittedValue ? {value: value || ""} : {})}
                        modules={modules}
                        formats={Editor.formats}
                        placeholder={placeholder}
                    />
                </div>
                {touched === 'true' && (error && <ValidationUI error={error} />)}
                {this.state.isTableSelectorOpen && (
                    <TableSelector
                        onSelect={this.handleTableSelect}
                        onClose={this.handleTableDialogClose}
                    />
                )}
            </div>
        )
    }
}

export default Editor
